/*
 * Main and demo navigation arrays
 *
 * 'to' attribute points to the route name, not the path url
 */

import type { RouteLocation } from 'vue-router';

export type BadgeVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
export type MenuItem = {
    badge?: string;
    'badge-variant'?: BadgeVariant;
    name: string;
    to?: string | RouteLocation;
    icon?: string;
    heading?: boolean;
    subActivePaths?: string;
    open?: boolean;
    sub?: MenuItem[];
    target?: string;
};

export interface Menu {
    main: MenuItem[];
    demo?: MenuItem[];
}

const menu = {
    main: [
        {
            name: 'Dashboard',
            to: 'dashboard',
            icon: 'material-symbols:dashboard',
        },
        {
            name: 'AI Assistant',
            to: 'chat',
            icon: 'material-symbols:smart-toy',
        },
        {
            name: 'Advertising',
            to: 'advertising',
            icon: 'material-symbols:campaign',
        },
        {
            name: 'Shipments',
            to: 'shipments',
            icon: 'material-symbols:local-shipping',
        },
        {
            name: 'Products',
            to: 'products',
            icon: 'material-symbols:package-2',
        },
        {
            name: 'SKUs',
            to: 'skus',
            icon: 'material-symbols:barcode-scanner',
        },
        {
            name: 'Stock',
            to: 'stocks',
            icon: 'material-symbols:inventory-2',
        },
        {
            name: 'Inventory',
            icon: 'material-symbols:pallet',
            sub: [
                {
                    name: 'By Date',
                    to: 'inventory-by-date',
                    icon: 'material-symbols:calendar-month',
                },
            ],
        },
        {
            name: 'Forecasts',
            to: 'forecasts',
            icon: 'material-symbols:show-chart',
        },
        {
            name: 'Sales Channels',
            to: 'sales-channels.list',
            icon: 'material-symbols:account-tree',
        },
        {
            name: 'Inventory',
            heading: true,
        },
        {
            name: 'Analysis',
            to: 'stocks-analysis',
            icon: 'material-symbols:pie-chart',
        },
        {
            name: 'Purchase Orders',
            to: 'purchase-orders',
            icon: 'material-symbols:receipt-long',
        },
        {
            name: 'Warehouse Transfers',
            to: 'transfers',
            icon: 'material-symbols:transfer-within-a-station',
            subActivePaths: 'transfers',
            open: true,
            sub: [
                {
                    name: 'All Transfers',
                    to: 'transfers',
                    icon: 'material-symbols:sync-alt',
                },
                {
                    name: 'Upcoming Transfers',
                    to: {
                        name: 'transfers',
                        query: {
                            draft: 'true',
                            live: 'false',
                            completed: 'false',
                            sort: 'shipping_date',
                            sortDesc: 'false',
                        },
                    },
                    icon: 'material-symbols:hourglass-empty',
                },
                {
                    name: 'Problem Transfers',
                    to: {
                        name: 'transfers',
                        query: {
                            draft: 'true',
                            live: 'true',
                            completed: 'true',
                            problems: true,
                        },
                    },
                    icon: 'material-symbols:warning',
                },
            ],
        },
        {
            name: 'Suppliers',
            to: 'suppliers',
            icon: 'material-symbols:handshake',
        },
        {
            name: 'Warehouses',
            to: 'warehouses',
            icon: 'material-symbols:warehouse',
        },
        {
            name: 'Fulfillment Centers',
            to: 'fulfillment-centers',
            icon: 'material-symbols:front-loader',
        },
        {
            name: 'Customer Support',
            heading: true,
        },
        {
            name: 'Dashboard',
            to: 'customer-support',
            icon: 'material-symbols:bar-chart',
        },
        {
            name: 'Orders',
            to: 'store-orders',
            icon: 'material-symbols:receipt',
            subActivePaths: 'store-orders',
            sub: [
                {
                    name: 'All Orders',
                    to: {
                        name: 'store-orders',
                    },
                    icon: 'material-symbols:assignment',
                },
                {
                    name: 'Problem Orders',
                    to: {
                        name: 'store-orders',
                        query: {
                            problems: true,
                        },
                    },
                    icon: 'material-symbols:bug-report',
                },
            ],
        },
        {
            name: 'Subscriptions',
            to: 'subscriptions',
            icon: 'material-symbols:repeat',
        },
        {
            name: 'Customers',
            to: 'customers',
            icon: 'material-symbols:person',
        },
        {
            name: 'Stores',
            to: 'stores',
            icon: 'material-symbols:storefront',
        },
        {
            name: 'Disputes',
            to: 'disputes',
            icon: 'material-symbols:balance',
        },
        {
            name: 'Accounting',
            heading: true,
        },
        {
            name: 'VAT Reports',
            to: 'accounting.vat-reports',
            icon: 'material-symbols:csv',
        },
        {
            name: 'Cross Border VAT',
            to: 'accounting.cross-border-vat',
            icon: 'material-symbols:summarize',
        },

        {
            name: 'DEBUGGING',
            heading: true,
        },
        {
            name: 'Health',
            to: 'health',
            icon: 'material-symbols:monitor-heart',
        },
        {
            name: 'Report Requests',
            to: 'report-requests',
            icon: 'material-symbols:description',
        },
    ],
};

export default menu as Menu;
